module.exports = __webpack_public_path__ + "5c700d5a1b08d0011311e6760e2cac6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_icon.png
// module id = 28
// module chunks = 1